// TEMPORARY hardcoded square-logo overrides for the mobile module-selection screen.
//
// That screen's design requires a SQUARE, icon-only logo, but the branding API
// currently exposes only a wide wordmark logo (`BusinessStore/logo`). Until the
// dynamic-menu API returns a square icon flavor per directory, we hardcode the
// square icon for the handful of directories that need to ship now. Any directory
// not listed here shows no logo at all (the grid renders the logo only when set).
//
// Matched case-insensitively as a substring of the directory `brand_name`, so
// e.g. both "localsearch" and "localsearch Playground" resolve to the same icon.
//
// TODO(VCITA2-14981): remove this file and its usage once the dynamic-menu API
// returns square icons, and resolve the icon from the API response instead.
//
// NOTE: if a directory only has a raster mark, swap its import to `.png`
// (url-loader → <img>); `.svg` imports are inlined as vectors by vue-svg-loader.
import vcitaSquareLogo from '@/assets/images/mobile-square-logos/vcita.svg';
import localsearchSquareLogo from '@/assets/images/mobile-square-logos/localsearch.svg';

const MOBILE_SQUARE_LOGO_OVERRIDES = [
  { brandNameIncludes: 'localsearch', logo: localsearchSquareLogo },
  { brandNameIncludes: 'vcita', logo: vcitaSquareLogo },
];

/**
 * Resolve the hardcoded square logo for a directory, matched by brand name.
 *
 * @param {string} [brandName] - the directory's `brand_name`.
 * @returns {(string|object|null)} the square logo asset, or null when the
 *   directory has no hardcoded override.
 */
export const getMobileSquareLogoOverride = (brandName) => {
  if (!brandName) return null;
  const normalized = brandName.toLowerCase();
  const override = MOBILE_SQUARE_LOGO_OVERRIDES.find(
    ({ brandNameIncludes }) => normalized.includes(brandNameIncludes),
  );
  return override ? override.logo : null;
};

export default MOBILE_SQUARE_LOGO_OVERRIDES;
